import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { getParentPath } from "../../../utils/goToParentRoute";
import { axisBenefits } from "../components/customBenefits/axisBenefits";
import { BenefitsCMSPage } from "./BenefitsCMSPage";

export const RouteAxisInsuranceDetails: React.FC<
  RouteComponentProps<{
    benefit: string;
  }>
> = ({ match, history }) => {
  const parentPath = getParentPath(history);

  const benefit = axisBenefits.find(
    benefit => benefit.slug === match.params.benefit
  );

  if (!benefit) {
    return null;
  }

  return <BenefitsCMSPage parentPath={parentPath} isFree benefit={benefit} />;
};
